module.exports = __webpack_public_path__ + "img/banner1.34947f08.png";